import type React from 'react'
import { useEffect } from 'react'

type Params = React.HTMLProps<HTMLScriptElement> & {
  src: string
  async?: boolean
}

export const useScript = ({ id = '', src, async = true, onLoad }: Params) => {
  useEffect(() => {
    const script = document.createElement('script')

    script.src = src
    script.async = async
    script.id = id
    if (onLoad) {
      script.onload = onLoad as unknown as EventListener
    }

    document.body.appendChild(script)

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script)
      }
    }
  }, [src, async, id, onLoad])
}
